import { graphql, useStaticQuery } from 'gatsby';

export function useCertificatesInfo(listOfCertificateId) {
  const {
    allCertificate: { nodes: certificates },
  } = useStaticQuery(graphql`
    query {
      allCertificate {
        nodes {
          id: certificateId
          mods
          name
          modalData {
            description
            title
          }
          images {
            alt
            modalWindow
            preview
          }
          link
        }
      }
    }
  `);

  if (listOfCertificateId) {
    return listOfCertificateId.map(id => certificates.find(certificate => certificate.id === id));
  }

  return certificates;
}
